import React from "react";
import PillarCard from "./PillarCard";
import "../App.css";

function FiscalIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 20V11M10 20V4M16 20V13M22 20V8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LegalIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6l8-4z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ContabilIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 3l9 5-9 5-9-5 9-5z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M3 12l9 5 9-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M3 17l9 5 9-5" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}

// Dados dos 3 pilares exibidos na Home. Como o PillarCard também é usado em
// outra página, mantenha essa lista aqui (específica desta seção/página) e
// reaproveite o componente PillarCard, passando outros dados, onde for preciso.
const PILLARS = [

  {
    icon: <ContabilIcon />,
    title: "Contábil",
    text: "Controle contábil completo, elaboração de demonstrações financeiras, conciliações e relatórios para apoiar decisões empresariais com segurança.",
  },
  {
    icon: <FiscalIcon />,
    title: "Fiscal",
    text: "Gestão das obrigações tributárias, apuração de impostos, entrega de declarações e acompanhamento das exigências fiscais, garantindo conformidade e redução de riscos.",
  },
  {
    icon: <LegalIcon />,
    title: "Legal",
    text: "Suporte societário, abertura e alteração de empresas, regularizações cadastrais e atendimento às exigências legais necessárias para o correto funcionamento do negócio.",
  },
];

export default function Pillars() {
  return (
    <section className="pillars">
      <div className="pillars__blob" aria-hidden="true" />

      <div className="pillars__container">
        <h2 className="pillars__title">Nossos Pilares de Atuação</h2>

        <div className="pillars__grid">
          {PILLARS.map((pillar, index) => (
            <PillarCard
              key={pillar.title}
              icon={pillar.icon}
              title={pillar.title}
              text={pillar.text}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
